import {
  formatProjectUnits,
  toProjectUnits,
  type Measurement,
} from "bear/measurements";
/**
 * Unit math for sketches. One tldraw page unit is one inch; Bear project
 * units are 32nds of an inch. tldraw page space is Y-down while Bear plans
 * are Y-up (north), and this module is the only place the flip happens:
 * everything user- or agent-facing (projection, actions) speaks Y-up
 * Measurements, everything stored in the tldraw records is Y-down page units.
 */
import { invariant } from "ts-invariant";

export const PROJECT_UNITS_PER_PAGE_UNIT = 32;

/** Authored values snap to Bear's project-unit lattice: 1/32" = 1/32 pu. */
export const IMPERIAL_QUANTUM = 1 / PROJECT_UNITS_PER_PAGE_UNIT;

export function pageToProjectUnits(pageUnits: number): number {
  return pageUnits * PROJECT_UNITS_PER_PAGE_UNIT;
}

export function projectToPageUnits(projectUnits: number): number {
  return projectUnits / PROJECT_UNITS_PER_PAGE_UNIT;
}

/** Round a page-unit value to the nearest quantum (1/32"). */
export function roundToQuantum(pageUnits: number): number {
  return Math.round(pageUnits / IMPERIAL_QUANTUM) * IMPERIAL_QUANTUM;
}

/** Parse a Measurement ("12ft", `6'4"`, 12) into page units. */
export function measurementToPageUnits(m: Measurement): number {
  const projectUnits = toProjectUnits(m);
  invariant(Number.isFinite(projectUnits), `Not a measurement: ${m}`);
  return projectToPageUnits(projectUnits);
}

/** Format page units as feet-and-inches for display and projection. */
export function formatPageUnits(pageUnits: number): string {
  return formatProjectUnits(Math.round(pageToProjectUnits(pageUnits)));
}

/** The one Y flip: Y-up world coordinate <-> Y-down page coordinate. */
export function yUpToPage(yUp: number): number {
  return -yUp;
}

export function pageToYUp(pageY: number): number {
  return -pageY;
}
